import { createReducer, createActions } from "reduxsauce"
import { mergeDeepRight } from "ramda"
import { EventTypes } from "redux-segment"

/* ------------- Types and Action Creators ------------- */
const { Types, Creators } = createActions({
  updateRatesQuery: ["query"]
})

export const RateTypes = Types
export default Creators

const DEFAULT_PROPERY_VALUE = 100000

export const INITIAL_STATE = {
  query: {
    WHERE: {
      amortization: 25,
      beacon: 700,
      ltv: 80,
      term: 5,
      embed: "lender",
      purpose: "Owner Occupied",
      regions: "ON",
      type: "Fixed"
    }
  },
  options: {
    propertyValue: JSON.stringify(DEFAULT_PROPERY_VALUE),
    downpaymentAmount: JSON.stringify(DEFAULT_PROPERY_VALUE * 0.25)
  }
}

const updateRatesQuery = (state, { query }) => {
  return {
    ...state,
    query: mergeDeepRight(state.query, query),
    meta: {
      analytics: {
        eventType: EventTypes.track,
        eventPayload: {
          event: Types.UPDATE_RATES_QUERY
        }
      }
    }
  }
}

export const reducer = createReducer(INITIAL_STATE, {
  [Types.UPDATE_RATES_QUERY]: updateRatesQuery
})



// WEBPACK FOOTER //
// ./src/containers/rates/rates.redux.js